import { render, staticRenderFns } from "./SynthesisTable.vue?vue&type=template&id=7fda1d8f&"
import script from "./SynthesisTable.vue?vue&type=script&lang=ts&"
export * from "./SynthesisTable.vue?vue&type=script&lang=ts&"
import style0 from "./SynthesisTable.vue?vue&type=style&index=0&id=7fda1d8f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports